import React, { useState , useEffect } from 'react';
import './Navbar.css';

function Navbar() {
const [state, setState] = useState(true);

 const toggleNavbar = () => {
       setState(!state);
   }    

//   const navbarControl = () => {
//       if(window.scrollY > 30) {
//           setState(true)
//       }
//       else {
//           setState(false)
//       }
//   }  

  useEffect(() => {
    //   window.addEventListener('scroll',navbarControl)

  }, [])
    return (
        <>
        <div className="navbar_container">
          <div className="navbar">
           <div className="logo">
               CodesandBots
           </div>
           <div className="searchbar">
               <input type="text" name="search" id="searchbar" placeholder="What you want to learn today?" />
               <i class="fa fa-search search_icon"></i>

           </div>
           <div className="navbar_options">
               <div className="navbar_option"><a href="#">Home</a> </div>
               <div className="navbar_option"><a href="#">My Classes</a> </div>

           </div>
           <div className="profile_image">
               <img src="./profile_image.jpg" alt="No image found" />
           </div>
 </div>
           <div className="toggle_navbar">
               <div className="toggle_icon"  onClick={toggleNavbar}> 
 {state?  <i class="fa fa-bars hamburger_menu "></i> : <div>   <i class="fa fa-close"></i>  <div className="toggle_options"  >
        <p className="toggle_option"  >Home</p>
                   <p className="toggle_option"  >My Classes</p>
        </div></div>}
               </div>
            
               <div className="toggle_logo">
               CodesandBots
               </div>
               <div className="toggle_searchicon">
               <i class="fa fa-search"></i>
               </div>
               <div className="cart_option">
               <i class="fa fa-shopping-cart" aria-hidden="true"></i>

               </div>
           </div>
          </div>  
        </>
    )
}

export default Navbar;
